import { useRef } from "react";
import { useInputEditor } from "src/components/useInputEditor";
import { useTinyMce } from "src/components/useTinyMce";
import styles from "./styles.module.scss";
import cx from "classnames";

type RenderType = "inputPlaceholder" | "buttonText";

interface OtpCustomization {
  headerText: string;
  descriptionText: string;
  buttonText: string;
  [key: string]: any; 
}
const otpPlaceholder = '/images/settings/viewerSettings/otpPlaceHolder.png'; 

// parent renders (header, description, button, inputPlaceholder) 
export const useOtpCustomization = ({ headerText, descriptionText, buttonText}: OtpCustomization) => {
  const header = useOtpCustomizationTinyMce({value: headerText}); // tinymce
  const description = useOtpCustomizationTinyMce({value: descriptionText}); // tinymce
  const button = useOtpCustomizationInput({ // inputEditor
    value: buttonText,
    viewerType: "buttonText",
  });

  return {
    header,
    description,
    button,
  };
};

// inputEditor Hook
export function useOtpCustomizationInput({value, viewerType}: {value: string, viewerType: RenderType}) {
   const values = useRef(value)
   return useInputEditor(values.current, viewerType);
}
// tinyMce Hook
export function useOtpCustomizationTinyMce({value}: {value: string}) {
   const values = useRef(value)
   return useTinyMce(values.current);
}

// Viewer
export const OtpCustomizationViewer = ({ HeaderText, Description ,ButtonText, buttonColor, buttonTextColor }) => (
  <div className={styles.viewerContainer}>
    <div className={styles.innerContainer}>
      <div className={styles.header}>
        <HeaderText/>
      </div>
      <div className={styles.subContainer}>
        <div className={styles.description}>
          <Description  />
        </div>
        <div className={styles.otpPlaceholder}>
          <img src={otpPlaceholder} alt="" />
          <p>OTP has expired, <span>Resend OTP</span></p>
        </div> 
      </div>
    </div>
    <ButtonText inlineStyles={{ backgroundColor: buttonColor, color: buttonTextColor }} />
 </div>
);

// Editor
export const OtpCustomizationEditor = ({  HeaderText, Description , ButtonText }) => (
  <div className={styles.editorContainer}>
    <div className={styles.header}>
       <h5 className={styles.title}>One-Time Password Customization</h5>
       <p className={styles.subText}>Security two-fold! Customize your OTP message here.</p>
    </div>
    <div className={styles.inputContainer}>
      <p className={styles.label}>Header Text</p>
      <HeaderText 
        classnames={cx(styles.tinyMce, styles.headerContainer)} 
        plugins = 'code noneditable, variable, widget,  autolink, link, textcolor, lists, paste'
        toolbar = 'bold italic | alignleft aligncenter alignright | numlist bullist | fontselect | fontsizeselect | forecolor backcolor | link'
        quickToolbar={true}
        transparentBackground={true}
      />
    </div>
    <div className={styles.inputContainer}>
      <p className={styles.label}>Description Text</p>
      <Description
         classnames={cx(styles.tinyMce, styles.descriptionContainer)}
         plugins = 'code noneditable, variable, widget,  autolink, link, textcolor, lists, paste'
        toolbar = 'bold italic | alignleft aligncenter alignright | numlist bullist | fontselect | fontsizeselect | forecolor backcolor | link'
        quickToolbar={true}
        transparentBackground={true}
      />
    </div>
    <div className={styles.inputGroup}>
      <div className={styles.inputContainer}>
         <p className={styles.label}>Button Text</p>
         <ButtonText maxLength={20}  />
      </div>
       <div className={styles.inputContainer}>
         
      </div>
    </div>
 </div>
);
